import { useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { authSlice } from '../features/authSlice';
import { useCookies } from 'react-cookie';
import { api } from '../common/api';
import { ACCESS_TOKEN, AUTH_TOKEN } from '../common/util' 

const useSignin = () => {
  const [cookies, setCookie] = useCookies([ACCESS_TOKEN, AUTH_TOKEN]);
  const dispatch = useDispatch();

  const goSignin = async (id?:string, password?:string) => {
    try {
      const basicAuth = id ? btoa(`${id}:${password}`) : cookies[AUTH_TOKEN];
      const response = await axios(`${api.base_url}/auth/admin-sign-in`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Basic ${basicAuth}`,
        },
      });

      if (response.status === 200) {
        dispatch(authSlice.actions.setAuth(response.data));
        const authToken = response.data.data.accessToken;
        setCookie(ACCESS_TOKEN, authToken);
        setCookie(AUTH_TOKEN, basicAuth);
      }
      return response.status
    } catch (error) {
      console.error(error);
    }
  };

  return { goSignin };
};

export default useSignin;